namespace Portico.Models.Enterprise {

	export interface IAttestation {
		attestationAttributeId: number;
		value: string;
    }

	export class Attestation implements IAttestation {
		attestationAttributeId: number;
		value: string;

		constructor(obj?: IAttestation) {
			this.attestationAttributeId = null;
			this.value = '';

			if (obj) {
				this.attestationAttributeId = obj.attestationAttributeId || null;
				this.value = obj.value || '';
            }
        }
    }
}
